module.exports = __webpack_public_path__ + "img/south.388409c8.png";